import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

interface UninvoicedProps {
  value: string | number;
  isProBono: boolean;
}

const Uninvoiced = ({ value, isProBono }: UninvoicedProps) => {
  return <p>{isProBono ? "N/A" : currency.formatByWorkspace(value)}</p>;
};

export default observer(Uninvoiced);
